import {} from '@reatom/framework';
import { getComponentDebugName as getComponentDebugNameFromNpmReact } from '@reatom/npm-react';
globalThis.DEVTOOLS = null;
export const DEVTOOLS_KEY = 'is-reatom-devtools-visible';
export const I18N_DEBUG_KEY = 'is-i18n-debug-mod-enabled';
export const getDevtools = () => globalThis.DEVTOOLS;
export const createDevtools = async (ctx) => {
    if (localStorage.getItem(DEVTOOLS_KEY) === 'true') {
        const { createDevtools } = await import('@reatom/devtools');
        globalThis.DEVTOOLS = createDevtools({ ctx });
    }
};
export const getComponentDebugName = (name) => getComponentDebugNameFromNpmReact(name).replace('Component.', '').replace(/_/g, '');
